import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    faqs: [],
    faq: null,
    links: null,
    meta: null,
    filter: {
      keyword: null,
      productCategoryId: null,
      productId: null,
      buId: null,
      buIds: [],
      popularcfg: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.filter = {
        keyword: null,
        productCategoryId: null,
        productId: null,
        buId: null,
        buIds: [],
        popularcfg: '',
      };
      state.faqs = [];
      state.faq = null;
    },
    SET_FAQS(state, data) {
      state.faqs = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_FAQ(state, data) {
      state.faq = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setFaq({ commit }, data) {
      commit('SET_FAQ', data);
    },

    find({ commit, state }) {
      let url = `/support_faqs?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('supportFaq'));
          return response.body;
        })
        .then((response) => {
          commit('SET_FAQS', response);
        });
    },

    findById({ commit }, id) {
      return http(`/support_faqs/${id}`)
        .then((response) => response.body)
        .then(typeAs('supportFaq'))
        .then((item) => {
          commit('SET_FAQ', item);
        });
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/support_faqs/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    destroy(_, id) {
      return http(`/support_faqs/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/support_faqs/${id}`, { method: 'PUT', data })
        : http('/support_faqs', { method: 'POST', data });

      return request.then((response) => response.body);
    },
  },
};
